import $ from 'jquery'
export const renderAccordions = (
  accordions,
  isCloseOthers = true
) => {
  if(!accordions.length) return

  const openAccordion = (accordion) => {
    const content = accordion.querySelector(".accordion-panel")
    const title = accordion.querySelector(".accordion-title")

    accordion.classList.add("accordion-active")
    title.setAttribute('aria-expanded', 'true')
    content.style.maxHeight = content.scrollHeight + "px"
  }

  const closeAccordion = (accordion) => {
    const content = accordion.querySelector(".accordion-panel")
    const title = accordion.querySelector(".accordion-title")

    accordion.classList.remove("accordion-active")
    title.setAttribute('aria-expanded', 'false')
    content.style.maxHeight = null
  }

  accordions.forEach((accordion, index) => {
    const title = accordion.querySelector(".accordion-title")
    const content = accordion.querySelector(".accordion-panel")

    title.setAttribute('aria-controls', `accordion-panel-${index}`)
    title.setAttribute('id', `accordion-trigger-${index}`)

    content.setAttribute('aria-labelledby', `accordion-trigger-${index}`)
    content.setAttribute('id', `accordion-panel-${index}`)

    title.onclick = () => {
      if (content.style.maxHeight) {
        closeAccordion(accordion)
      } else {
        if(isCloseOthers){
          accordions.forEach((accordion) => closeAccordion(accordion))
        }
        openAccordion(accordion)
      }
    }

    title.addEventListener("keydown", function (e) {
      const code = e.keyCode || e.wich
      
      if (code === 32 || code === 13) {
        e.preventDefault()
        title.click()
      }
    })
  })
}
